import React, { useRef, useState } from "react";

const DECIMAL_INPUT_REGEX = /^\d*\.?\d*$/;

const SwapAmountInput = ({
  value,
  onChange,
  formatLargeNumber,
  disabled = false,
}) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const displayText = value ? formatLargeNumber(value) : "";

  const handleChange = (event) => {
    const nextValue = event.target.value;
    if (nextValue === "" || DECIMAL_INPUT_REGEX.test(nextValue)) {
      onChange(nextValue);
    }
  };

  return (
    <div
      className={`relative w-full ${disabled ? "cursor-default" : "cursor-text"}`}
      onClick={() => !disabled && inputRef.current?.focus()}
    >
      <div
        className="flex items-center text-[24px] sm:text-[30px] lg:text-[38px] font-bold text-white whitespace-nowrap overflow-x-auto min-h-[1.15em]"
        style={{
          scrollbarWidth: "thin",
          scrollbarColor: "#4b5563 #1f2937",
        }}
      >
        <span>{displayText || (!isFocused ? "0" : "\u00a0")}</span>
        {isFocused && !disabled && (
          <span
            className="inline-block w-[2px] sm:w-[3px] self-center h-[0.85em] bg-white ml-0.5 flex-shrink-0"
            style={{ animation: "caret-blink 1s step-end infinite" }}
          />
        )}
      </div>
      <input
        ref={inputRef}
        type="text"
        inputMode="decimal"
        value={value}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
        className="swap-amount-input absolute inset-0 opacity-0 w-full h-full !border-0 !p-0 !bg-transparent focus:!shadow-none focus:!border-0 disabled:cursor-default cursor-text"
        autoComplete="off"
        aria-label="Amount"
      />
    </div>
  );
};

export default SwapAmountInput;
